"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KPayUserPoolEnum = void 0;
var KPayUserPoolEnum;
(function (KPayUserPoolEnum) {
    KPayUserPoolEnum["uat"] = "https://kushki-static-dev.s3.amazonaws.com/kpay/kpay_user_pool_dev.json";
    KPayUserPoolEnum["prod"] = "https://kushki-static.s3.amazonaws.com/kpay/kpay_user_pool_prod.json";
})(KPayUserPoolEnum = exports.KPayUserPoolEnum || (exports.KPayUserPoolEnum = {}));
